import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useGetVendorMeQuery } from '../../store/vendorApi';

const ONBOARDING_DEFERRED_KEY = 'onboardingDeferred';

/**
 * Handles the root path "/": shows a loading spinner while auth resolves,
 * redirects to /onboarding if vendor has not completed onboarding
 * (and has not clicked "Complete later"), otherwise to /dashboard.
 */
const DefaultRedirect: React.FC = () => {
  const { isAuthenticated, isLoading: isAuthLoading, user } = useAuth();
  const { data: vendor, isLoading: isLoadingVendor } = useGetVendorMeQuery(undefined, {
    skip: !isAuthenticated || user?.role !== 'vendor',
  });

  if (isAuthLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role === 'vendor' && isLoadingVendor) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600" />
      </div>
    );
  }

  if (user?.role === 'vendor' && vendor && !vendor.onboardingCompleted) {
    const hasDeferred = typeof sessionStorage !== 'undefined' && sessionStorage.getItem(ONBOARDING_DEFERRED_KEY) === 'true';
    return <Navigate to={hasDeferred ? '/dashboard' : '/onboarding'} replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default DefaultRedirect;
